import { z } from "zod";

export const AiGetScreenshotRecommendationsRequestBodySchema = z.object({
  url: z.string(),
  shopId: z.string(),
});

export type AiGetScreenshotRecommendationsRequestBodyType = z.infer<
  typeof AiGetScreenshotRecommendationsRequestBodySchema
>;

export const AiGetScreenshotRecommendationsResponseSchema = z.object({
  screenshot: z.string().nullable(),
  recommendations: z
    .object({ order: z.number(), recommendation: z.string() })
    .array(),
});

export type AiGetScreenshotRecommendationsResponseBodyType = z.infer<
  typeof AiGetScreenshotRecommendationsResponseSchema
>;
